export enum UsersFilter {
  ALL = '',
  AGENT = 'AGENT',
  ARBITRATOR = 'ARBITRATOR',
  LANDLORD = 'LANDLORD',
  TENANT = 'TENANT',
  INTERNAL = 'INTERNAL',
}

export enum UsersSort {
  CREATED_AT = 'CREATED_AT',
}
